module.exports = "a {\n  cursor: pointer; }\n\nlabel::first-letter {\n  text-transform: capitalize; }\n"